import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { QrScanner } from "@/components/assets/qr-scanner";
import { ArrowLeft } from "lucide-react";
import { useGoBack } from "@/hooks/use-go-back";

export const Route = createFileRoute("/_authenticated/assets/scan")({
  component: ScanPage,
});

function ScanPage() {
  const navigate = useNavigate();
  const goBack = useGoBack({ to: "/assets" });

  const handleScan = (assetId: string) => {
    navigate({
      to: "/assets/$assetId/checkout",
      params: { assetId },
    });
  };

  return (
    <div className="flex flex-col items-center min-h-[80vh] justify-center px-4">
      <div className="w-full max-w-sm space-y-6">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={goBack} aria-label="Back">
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-xl font-bold text-text-primary">
            Scan Asset QR Code
          </h1>
        </div>

        <QrScanner
          onScan={handleScan}
          onError={(error) => console.warn("QR scan error:", error)}
        />

        <p className="text-xs text-muted-foreground text-center">
          Point your camera at the QR code label on the asset. The code should
          be in the format pph:asset:ID.
        </p>
      </div>
    </div>
  );
}
